<div class="dialog-message">
  <p>{{ message }}</p>
</div>
